import { render, staticRenderFns } from "./BlockedContacts.vue?vue&type=template&id=eabb5c5e&"
import script from "./BlockedContacts.vue?vue&type=script&lang=js&"
export * from "./BlockedContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports